import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { panelStateAtom, totalIssuesCountAtom, totalRulesCountAtom } from '../atoms/session-atoms';
import { BiScreenTypes } from '../bi/types';
import { getScanByRuleStaticAndSiteLevelPages, getScanByRuleVertical } from '../bi/utils/get-scan-by-rule';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
import { useBiLogger } from './use-bi-logger';
import { useSessionInfoContext } from './use-session-info-context';
export const useScanSiteBiEvents = () => {
  const biLogger = useBiLogger();
  const totalIssuesCount = useAtomValue(totalIssuesCountAtom);
  const totalRulesCount = useAtomValue(totalRulesCountAtom);
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const {
    referral
  } = useSessionInfoContext();
  const origin = referral || a11yWizardAdapter.getEntryPoint() || BiScreenTypes.Direct;
  const panelState = useAtomValue(panelStateAtom);
  const {
    groupsDataMap
  } = panelState;
  const sendBiLoggerScanEvents = useCallback(() => {
    const pagesRulesBreakDown = getScanByRuleStaticAndSiteLevelPages(groupsDataMap);
    pagesRulesBreakDown.forEach(rule => {
      biLogger.scanSiteFinishedBreakdownPerTask({
        ...rule,
        origin
      });
    });
    biLogger.scanSiteFinished({
      failed_task_count: totalIssuesCount,
      isFirstScan: origin === BiScreenTypes.WelcomeScreen,
      origin,
      task_count: totalRulesCount
    });

    // Get vertical pages rule breakdowns grouped by item type
    const itemTypeRuleBreakdowns = getScanByRuleVertical(groupsDataMap);
    itemTypeRuleBreakdowns.forEach(_ref => {
      let [pageType, ruleBreakdown] = _ref;
      const rulesData = ruleBreakdown;
      rulesData.forEach(rule => {
        biLogger.scanSiteFinishedBreakdownPerTaskVerticalsPages({
          is_cross: false,
          page_count: Object.keys(rule.payload).length,
          page_type: pageType,
          payload: JSON.stringify(rule.payload),
          task_name: rule.taskName
        });
      });
    });
  }, [groupsDataMap, biLogger, totalIssuesCount, origin, totalRulesCount]);
  return sendBiLoggerScanEvents;
};
//# sourceMappingURL=use-scan-site-bi-events.js.map